(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-addon"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('product-addon')) {
    window.customElements.define(
      'product-addon',
      class ProductAddon extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.checkbox = this.querySelector('input[type="checkbox"]');
          this.form = document.getElementById(this.getAttribute('form'));

          if (!this.checkbox || !this.form) {
            return;
          }

          const listenerOptions = { signal: this.abortController.signal };

          this.checkbox.addEventListener('change', () => this.updateButtonPrice(), listenerOptions);
          this.form.addEventListener('formdata', (event) => this.updateFormData(event.formData), listenerOptions);
          this.form.addEventListener('product:rerender', (event) => this.updateFromRerender(event), listenerOptions);
          this.updateButtonPrice();
        }

        disconnectedCallback() {
          this.abortController?.abort();
        }

        updateButtonPrice() {
          const price = this.form?.querySelector('.buy-buttons__price');

          if (price) {
            price.textContent = this.checkbox.checked ? this.dataset.combinedPrice : this.dataset.mainPrice;
          }
        }

        updateFromRerender(event) {
          const matchingAddon = Array.from(event.detail.htmlFragment?.querySelectorAll('product-addon') || []).find(
            (addon) => addon.getAttribute('form') === this.form.id
          );

          if (!matchingAddon) {
            this.checkbox.checked = false;
            this.hidden = true;
            return;
          }

          this.hidden = false;
          this.dataset.addonVariantId = matchingAddon.dataset.addonVariantId;
          this.dataset.mainPrice = matchingAddon.dataset.mainPrice;
          this.dataset.combinedPrice = matchingAddon.dataset.combinedPrice;
          queueMicrotask(() => this.updateButtonPrice());
        }

        updateFormData(formData) {
          if (!this.checkbox.checked) {
            return;
          }

          const mainVariantId = formData.get('id');

          if (!mainVariantId || !this.dataset.addonVariantId) {
            return;
          }

          const quantity = formData.get('quantity') || '1';
          const sellingPlan = formData.get('selling_plan');
          const mainItemProperties = [];
          const fieldsToDelete = new Set(['id', 'quantity', 'selling_plan']);

          for (const [name, value] of formData.entries()) {
            if (name.startsWith('properties[') && name.endsWith(']')) {
              const propertyName = name.slice('properties['.length, -1);
              mainItemProperties.push([`items[0][properties][${propertyName}]`, value]);
              fieldsToDelete.add(name);
            }
          }

          fieldsToDelete.forEach((name) => formData.delete(name));
          formData.set('items[0][id]', mainVariantId);
          formData.set('items[0][quantity]', quantity);

          if (sellingPlan) {
            formData.set('items[0][selling_plan]', sellingPlan);
          }

          mainItemProperties.forEach(([name, value]) => formData.append(name, value));
          formData.set('items[1][id]', this.dataset.addonVariantId);
          formData.set('items[1][quantity]', quantity);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sibling-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    function (event) {
      var disclosure = event.target;

      if (!(disclosure instanceof HTMLDetailsElement)) {
        return;
      }

      if (!disclosure.matches('.sibling-swatches__overflow-disclosure') || !disclosure.open) {
        return;
      }

      var template = disclosure.querySelector('template');

      if (!template) {
        return;
      }

      disclosure.replaceWith(template.content.cloneNode(true));
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
